import FieldFormatSelection from "../../../../../../components/BuilderComponents/FieldFormateSelection";
import {
  InlineColorMasterdataSelection,
  TableFieldAction
} from "../../../../../../components/EditComponents/EditField";
import Input from "../../../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../../../components/FormComponents/SingleSelectBox";
import BuilderTabs from "../../../../../../Layouts/BuilderTabs";

const EditFieldColumn = ({ field, handleChangeField, tableId, tableType }) => {
  const handleFieldActionChange = (data) => {
    const newConfig = { ...field, field_action: data };
    handleChangeField(newConfig);
  };

  const handleDisplayName = (e) => {
    const newConfig = { ...field, [e.target.name]: e.target.value };
    handleChangeField(newConfig);
  };

  const handleUpdateConfig = (name, value) => {
    const newConfig = { ...field, config: { ...field.config, [name]: value } };
    handleChangeField(newConfig);
  };

  const handleCheckbox = (e, keyName = "config") => {
    const { checked, name } = e.target;
    const newConfig = { ...field, [keyName]: { ...field[keyName], [name]: checked } };
    handleChangeField(newConfig);
  };
  const handleSelect = (name, value, keyName = "config") => {
    const newConfig = { ...field, [keyName]: { ...field[keyName], [name]: value } };
    handleChangeField(newConfig);
  };

  const renderChipsAndAvatar = (type, editElementData) => {
    switch (type) {
      case "textfield":
      case "email":
      case "learning-text":
      case "varchar":
        return (
          <>
            <Input
              type="checkbox"
              label="Chips Format"
              name="show_chips"
              checked={editElementData.config?.show_chips}
              onChange={handleCheckbox}
            />
            <Input
              type="checkbox"
              label="Avatar"
              name="show_avatar"
              checked={editElementData.config?.show_avatar}
              onChange={handleCheckbox}
            />
          </>
        );
      case "select":
      case "id-gen":
      case "multi-date":
      case "date":
      case "radio":
        return (
          <Input
            type="checkbox"
            label="Chips Format"
            name="show_chips"
            checked={editElementData.config?.show_chips}
            onChange={handleCheckbox}
          />
        );
      case "number":
      case "int":
        return (
          <>
            <Input
              type="checkbox"
              label="Chips Format"
              name="show_chips"
              checked={editElementData.config?.show_chips}
              onChange={handleCheckbox}
            />
          </>
        );
      case "grid":
      case "recordset":
      case "recordset-list":
        return (
          <>
            <Input
              type="checkbox"
              label="Table Format"
              name="table_format"
              checked={editElementData.layout_config?.table_format}
              onChange={(e) => handleCheckbox(e, "layout_config")}
            />
            <Input
              type="checkbox"
              label="Show serial number"
              name="show_serial_number"
              checked={editElementData.layout_config?.show_serial_number}
              onChange={(e) => handleCheckbox(e, "layout_config")}
            />
          </>
        );
      default:
        return null;
    }
  };

  const renderFieldFormatSelection = (type, editElementData) => {
    switch (type) {
      case "number":
        return (
          <>
            <FieldFormatSelection
              type="number"
              value={editElementData.config?.format || ""}
              onChange={(newValue) => handleSelect("format", newValue)}
            />
            <FieldFormatSelection
              type="currency"
              value={editElementData.config?.currency_code || ""}
              onChange={(newValue) => handleSelect("currency_code", newValue)}
              label="Currency Format"
            />
          </>
        );
      case "date":
      case "date-range":
        return (
          <FieldFormatSelection
            type="date"
            value={editElementData.config?.format || ""}
            onChange={(newValue) => handleSelect("format", newValue)}
          />
        );
      case "time":
        return (
          <FieldFormatSelection
            type="time"
            value={editElementData.config?.format || ""}
            onChange={(newValue) => handleSelect("format", newValue)}
          />
        );
      case "datetime":
        return (
          <FieldFormatSelection
            type="datetime"
            value={editElementData.config?.format || ""}
            onChange={(newValue) => handleSelect("format", newValue)}
          />
        );
      default:
        return null;
    }
  };

  const renderFieldSpecificSelection = (type, editElementData) => {
    switch (type) {
      case "json":
        return (
          <div>
            <Input
              type="checkbox"
              label="Raw Json"
              name="raw_json"
              checked={editElementData?.config?.raw_json ?? false}
              onChange={handleCheckbox}
            />
          </div>
        );
      default:
        return null;
    }
  };

  if (!field) {
    return null;
  }
  const widthTypeOptions = [
    { id: "width", name: "width" },
    { id: "max_width", name: "max width" },
    { id: "min_width", name: "min width" }
  ];
  return (
    <BuilderTabs
      tabs={[
        {
          label: "Basic",
          content: (
            <div className="p_3 flex_column gap_4">
              <Input
                label="Display Name"
                onChange={handleDisplayName}
                name="custom_label"
                value={field.custom_label || ""}
                placeholder={field.display}
              />
              <Input
                label="Enter Placeholder"
                onChange={handleDisplayName}
                name="placeholder"
                value={field.placeholder || ""}
                placeholder={field.display}
              />
              <SingleSelectBox
                selectedData={field.config?.width_type || ""}
                options={widthTypeOptions}
                onChange={(obj) => handleUpdateConfig("width_type", obj.id)}
                placeholder="select"
                label="Select Width Type"
              />
              {field.config?.width_type && (
                <>
                  <Input
                    label="Width(in pixels)"
                    type="number"
                    name="width_value"
                    onChange={(e) => handleUpdateConfig(e.target.name, e.target.value)}
                    value={field.config?.width_value || ""}
                  />
                </>
              )}
              <div className="d_flex gap_3">{renderChipsAndAvatar(field.field_type, field)}</div>
              {/* align_value_vertical */}
              <Input
                type="checkbox"
                label="Separator"
                name="align_value_vertical"
                checked={field.config?.align_value_vertical}
                onChange={handleCheckbox}
              />
              {renderFieldFormatSelection(field.field_type, field)}
              {renderFieldSpecificSelection(field.field_type, field)}
              <InlineColorMasterdataSelection
                colorConfigType={field.config?.color_config_type}
                handleEditElementData={handleUpdateConfig}
                colorMasterData={field.config?.color_master_data || ""}
                colorIf={field.config?.colorif || []}
              />
            </div>
          )
        },
        {
          label: "Action",
          content: (
            <div className="p_3 flex_column gap_4">
              <TableFieldAction
                fieldConfig={field}
                onChange={handleFieldActionChange}
                tableID={tableId}
                tableType={tableType}
              />
            </div>
          )
        }
      ]}
    />
  );
};

export default EditFieldColumn;
